import i18n from '@/base/i18n/index'
import { ToolsClass } from '@/base/class/tools.class'
import { getAppConfig } from '@/base/config/app-config'

export const PAYWAY_PSD2_TYPES = {
  pis: 'PIS',
  ais: 'AIS',
}

export const PAYWAY_GROUPS_TYPES = {
  promo: 'PROMO',
  auto: 'AUTO',
  blik: 'BLIK',
  blikAuto: 'AUTO_BLIK',
  blikPayLater: 'BLIK_PAY_LATER',
  card: 'CARD',
  pbl: 'PBL',
  wallet: 'WALLET',
  googlePay: 'GOOGLE_PAY',
  applePay: 'APPLE_PAY',
  visaMobile: 'VISAMOBILE',
  installments: 'INSTALLMENTS',
  otp: 'OTP',
  transfer: 'TRANSFER',
  companyPayments: 'COMPANY_PAYMENTS',
  other: 'OTHER',
}

export const PAYWAY_GROUPS_FRONT_API_MAP = {
  PROMO: PAYWAY_GROUPS_TYPES.promo,
  AUTO: PAYWAY_GROUPS_TYPES.auto,
  AUTO_BLIK: PAYWAY_GROUPS_TYPES.blikAuto,
  BLIK: PAYWAY_GROUPS_TYPES.blik,
  BNPL_BLIK: PAYWAY_GROUPS_TYPES.blikPayLater,
  CARD: PAYWAY_GROUPS_TYPES.card,
  PBL: PAYWAY_GROUPS_TYPES.pbl,
  WALLET: PAYWAY_GROUPS_TYPES.wallet,
  GOOGLE_PAY: PAYWAY_GROUPS_TYPES.googlePay,
  APPLE_PAY: PAYWAY_GROUPS_TYPES.applePay,
  VISAMOBILE: PAYWAY_GROUPS_TYPES.visaMobile,
  INSTALLMENTS: PAYWAY_GROUPS_TYPES.installments,
  BNPL: PAYWAY_GROUPS_TYPES.otp,
  FR: PAYWAY_GROUPS_TYPES.transfer,
  B2B: PAYWAY_GROUPS_TYPES.companyPayments,
}

export const PAYWAY_GROUPS_ORDER = {
  [PAYWAY_GROUPS_TYPES.promo]: 1,
  [PAYWAY_GROUPS_TYPES.blikAuto]: 2,
  [PAYWAY_GROUPS_TYPES.auto]: 3,
  [PAYWAY_GROUPS_TYPES.blik]: 4,
  [PAYWAY_GROUPS_TYPES.card]: 5,
  [PAYWAY_GROUPS_TYPES.pbl]: 6,
  [PAYWAY_GROUPS_TYPES.visaMobile]: 7,
  [PAYWAY_GROUPS_TYPES.wallet]: 8,
  [PAYWAY_GROUPS_TYPES.googlePay]: 9,
  [PAYWAY_GROUPS_TYPES.applePay]: 10,
  [PAYWAY_GROUPS_TYPES.installments]: 11,
  [PAYWAY_GROUPS_TYPES.blikPayLater]: 12,
  [PAYWAY_GROUPS_TYPES.otp]: 13,
  [PAYWAY_GROUPS_TYPES.companyPayments]: 14,
  [PAYWAY_GROUPS_TYPES.transfer]: 15,
  [PAYWAY_GROUPS_TYPES.other]: 16,
}

export const PAYWAY_GROUP_MODEL = {
  id: null,
  type: null,
  label: null,
  description: null,
  tooltip: null,
  icon: null,
  order: null,
  payways: [],
  active: true,
}

export const PAYWAY_REQUIRED_PARAMS_TYPES = {
  string: 'STRING',
  boolean: 'BOOLEAN',
  currency: 'CURRENCY',
  date: 'DATE',
  integer: 'INTEGER',
  long: 'LONG',
  money: 'MONEY',
  recurringAcceptanceState: 'RECURRING_ACCEPTANCE_STATE',
  recurringAction: 'RECURRING_ACTION',
  transactionSettlementMode: 'TRANSACTION_SETTLEMENT_MODE',
  walletType: 'WALLET_TYPE',
}

export const PAYWAY_REQUIRED_PARAMS_TYPES_MAP = {
  [PAYWAY_REQUIRED_PARAMS_TYPES.string]: 'text',
  [PAYWAY_REQUIRED_PARAMS_TYPES.boolean]: 'checkbox',
  [PAYWAY_REQUIRED_PARAMS_TYPES.currency]: 'text',
  [PAYWAY_REQUIRED_PARAMS_TYPES.date]: 'text',
  [PAYWAY_REQUIRED_PARAMS_TYPES.integer]: 'text',
  [PAYWAY_REQUIRED_PARAMS_TYPES.long]: 'text',
  [PAYWAY_REQUIRED_PARAMS_TYPES.money]: 'text',
  [PAYWAY_REQUIRED_PARAMS_TYPES.recurringAcceptanceState]: 'checkbox',
  [PAYWAY_REQUIRED_PARAMS_TYPES.recurringAction]: 'text',
  [PAYWAY_REQUIRED_PARAMS_TYPES.transactionSettlementMode]: 'text',
  [PAYWAY_REQUIRED_PARAMS_TYPES.walletType]: 'text',
}

export const getRequiredParamFieldType = (paramType) => {
  return PAYWAY_REQUIRED_PARAMS_TYPES_MAP[paramType]
}

export const isRequiredParamFieldTypeCheckbox = (paramType) => {
  return getRequiredParamFieldType(paramType) === 'checkbox'
}

export const isRequiredParamFieldTypeText = (paramType) => {
  return ['text', 'date', 'number'].includes(getRequiredParamFieldType(paramType))
}

export const getRequiredParamLabel = (paramName) => {
  return i18n.global.t(`requiredParams.${paramName}.label`)
}

export const getRequiredParamFlowLabel = (paramName) => {
  return i18n.global.t(`requiredParams.${paramName}.flowLabel`)
}

export const getRequiredParamPlaceholder = (paramName) => {
  return i18n.global.t(`requiredParams.${paramName}.placeholder`)
}

export const paywayGroupsList = () => {
  const GROUPS_ORDER = getAppConfig('PAYWAY_GROUPS_ORDER_CONFIG', PAYWAY_GROUPS_ORDER)
  const PAYWAY_GROUPS = [
    {
      type: PAYWAY_GROUPS_TYPES.auto,
      label: i18n.global.t('configuration.paywayGroups.auto.label'),
      labelInitWithRefund: i18n.global.t('configuration.paywayGroups.auto.labelInitWithRefund'),
      labelInitWithRefundOrange: i18n.global.t('configuration.paywayGroups.auto.labelInitWithRefundOrange'),
      labelInitWithPayment: i18n.global.t('configuration.paywayGroups.auto.labelInitWithPayment'),
      description: i18n.global.t('configuration.paywayGroups.auto.description'),
      descriptionInitWithRefund: i18n.global.t('configuration.paywayGroups.auto.descriptionInitWithRefund'),
      descriptionInitWithPayment: i18n.global.t('configuration.paywayGroups.auto.descriptionInitWithPayment'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.auto],
    },
    {
      type: PAYWAY_GROUPS_TYPES.blik,
      label: i18n.global.t('configuration.paywayGroups.blik.label'),
      description: i18n.global.t('configuration.paywayGroups.blik.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.blik],
    },
    {
      type: PAYWAY_GROUPS_TYPES.blikAuto,
      label: i18n.global.t('configuration.paywayGroups.blikAuto.label'),
      description: i18n.global.t('configuration.paywayGroups.blikAuto.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.blikAuto],
    },
    {
      type: PAYWAY_GROUPS_TYPES.card,
      label: i18n.global.t('configuration.paywayGroups.card.label'),
      description: i18n.global.t('configuration.paywayGroups.card.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.card],
    },
    {
      type: PAYWAY_GROUPS_TYPES.pbl,
      label: i18n.global.t('configuration.paywayGroups.pbl.label'),
      description: i18n.global.t('configuration.paywayGroups.pbl.description'),
      descriptionVerify: i18n.global.t('configuration.paywayGroups.pbl.descriptionVerify'),
      descriptionServiceVerify: i18n.global.t('configuration.paywayGroups.pbl.descriptionServiceVerify'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.pbl],
    },
    {
      type: PAYWAY_GROUPS_TYPES.visaMobile,
      label: i18n.global.t('configuration.paywayGroups.visaMobile.label'),
      description: i18n.global.t('configuration.paywayGroups.visaMobile.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.visaMobile],
    },
    {
      type: PAYWAY_GROUPS_TYPES.wallet,
      label: i18n.global.t('configuration.paywayGroups.wallet.label'),
      description: i18n.global.t('configuration.paywayGroups.wallet.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.wallet],
    },
    {
      type: PAYWAY_GROUPS_TYPES.googlePay,
      label: i18n.global.t('configuration.paywayGroups.googlePay.label'),
      description: i18n.global.t('configuration.paywayGroups.googlePay.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.googlePay],
    },
    {
      type: PAYWAY_GROUPS_TYPES.applePay,
      label: i18n.global.t('configuration.paywayGroups.applePay.label'),
      description: i18n.global.t('configuration.paywayGroups.applePay.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.applePay],
    },
    {
      type: PAYWAY_GROUPS_TYPES.installments,
      label: i18n.global.t('configuration.paywayGroups.installments.label'),
      description: null,
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.installments],
    },
    {
      type: PAYWAY_GROUPS_TYPES.otp,
      label: i18n.global.t('configuration.paywayGroups.otp.label'),
      description: i18n.global.t('configuration.paywayGroups.otp.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.otp],
    },
    {
      type: PAYWAY_GROUPS_TYPES.blikPayLater,
      label: i18n.global.t('configuration.paywayGroups.blikPayLater.label'),
      description: i18n.global.t('configuration.paywayGroups.blikPayLater.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.otp],
    },
    {
      type: PAYWAY_GROUPS_TYPES.companyPayments,
      label: i18n.global.t('configuration.paywayGroups.companyPayments.label'),
      description: i18n.global.t('configuration.paywayGroups.companyPayments.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.companyPayments],
    },
    {
      type: PAYWAY_GROUPS_TYPES.transfer,
      label: i18n.global.t('configuration.paywayGroups.transfer.label'),
      description: i18n.global.t('configuration.paywayGroups.transfer.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.transfer],
    },
    {
      type: PAYWAY_GROUPS_TYPES.other,
      label: i18n.global.t('configuration.paywayGroups.other.label'),
      description: i18n.global.t('configuration.paywayGroups.other.description'),
      order: GROUPS_ORDER[PAYWAY_GROUPS_TYPES.otp],
    },
  ]
  const groups = []
  PAYWAY_GROUPS.forEach((group) => {
    const newGroupModel = ToolsClass.deepExtend(PAYWAY_GROUP_MODEL)
    const newGroup = Object.assign({}, newGroupModel, group)
    // newGroup.id = ToolsClass.generateUUID()
    groups.push(newGroup)
  })
  return groups
}

/**
 * Grupy jednokanałowe portfeli wydzielone z `WALLET` (PEP-1249).
 */
const SINGLE_WALLET_GROUP_TYPES = [PAYWAY_GROUPS_TYPES.googlePay, PAYWAY_GROUPS_TYPES.applePay]

/**
 * Kanał portfela z grupy jednokanałowej, którego NIE da się uruchomić na tym urządzeniu.
 *
 * Google Pay wymaga bezpiecznego kontekstu, Apple Pay - `ApplePaySession.canMakePayments()`. Dla grupy
 * zbiorczej `WALLET` wygasza taki kanał `PaywayList.vue`, ale grupy jednokanałowe listy kanałów nie
 * renderują (`canShowPaywayList()` w `Paywall/Form.vue`), więc **omijają ten filtr** - dostępność musi
 * być sprawdzona na poziomie grupy.
 *
 * ⚠️ Dla Google Pay odpowiedź jest niepełna, dopóki nie odpowie `isReadyToPay()` - dopiero wtedy
 * `GooglePay.vue` zgłasza brak wsparcia przez `walletAvailability.js` i ten predykat zaczyna zwracać
 * kanał (SDKN-111). Pierwsze wejście w grupę zawsze przechodzi, więc komunikat „to urządzenie nie
 * obsługuje Google Pay" musi też umieć wystawić sam `GooglePay.vue`.
 *
 * @param {object} group
 * @returns {object|null} kanał bez wsparcia na urządzeniu albo `null`
 */
export const getUnavailableWalletPayway = (group) => {
  if (!SINGLE_WALLET_GROUP_TYPES.includes(group?.type)) {
    return null
  }
  return (group.payways ?? []).find((payway) => !ToolsClass.isWalletPaywayAvailable(payway.id)) ?? null
}

/**
 * Czy w grupę można wejść: aktywna po stronie serwisu **oraz** z portfelem uruchamialnym na urządzeniu.
 *
 * ⚠️ Wszystkie ścieżki wyboru grupy muszą pytać o to samo. `active` z API nie wystarcza: grupa
 * z niedostępnym portfelem przychodzi jako aktywna, a wybrana nigdy nie wystawi przycisku płatności.
 * Dotyczy to zarówno kliknięcia w kafel (`PaywayGroup.vue`), jak i automatycznego wyboru jedynej grupy
 * w odpowiedzi (`Paywall.vue`) oraz wstępnego wyboru z `lastUsedPayway`.
 *
 * @param {object} group
 * @returns {boolean}
 */
export const isPaywayGroupAvailable = (group) => !!group?.active && !getUnavailableWalletPayway(group)

export const AUTO_TYPES = {
  creditCard: {
    id: 1503,
    label: 'Credit Card',
  },
}
export const AUTO_ID_LIST = [AUTO_TYPES.creditCard.id]

export const CARD_TYPES = {
  creditCard: {
    id: 1500,
    label: 'Credit Card',
  },
}
export const CARD_ID_LIST = [CARD_TYPES.creditCard.id]

export const WALLET_TYPES = {
  visaCheckout: {
    id: 1511,
    label: 'Visa Checkout',
  },
  googlePay: {
    id: 1512,
    label: 'Google Pay',
  },
  applePay: {
    id: 1513,
    label: 'Apple Pay',
  },
  masterPass: {
    id: 1505,
    label: 'MasterPass',
  },
}

export const VISA_MOBILE_TYPES = {
  visaMobile: {
    id: 1523,
    label: 'VisaMobile',
  },
}

export const OTP_TYPES = {
  payka: {
    id: 701,
    label: 'Payka',
    icon: 'payka',
  },
  smartney: {
    id: 700,
    label: 'Smartney',
    icon: 'smartney',
  },
  paypo: {
    id: 705,
    label: 'PayPo',
    icon: 'paypo',
  },
  blikPayLater: {
    id: 523,
    label: 'BLIK płacę później',
    icon: 'blikPayLater',
  },
}

export const INSTALLMENT_TYPES = {
  alior: {
    id: 1506,
    label: 'Alior Raty',
  },
  oney: {
    id: 707,
    label: 'Oney Raty',
  },
  santander: {
    id: 711,
    label: 'Erste Raty',
  },
}

export const BACKEND_PAYWAY_TYPES = {
  type1: 'Szybki Przelew',
  type2: 'Płatność automatyczna',
  type3: 'Karta płatnicza',
  type4: 'Kup teraz, zapłać później',
  type5: 'Raty online',
  type6: 'BLIK',
  type7: 'Portfele elektroniczne',
  type8: 'PBC',
  type9: 'PBL',
  type10: 'FR',
  type11: 'PG',
  type12: 'PBI',
  type13: 'PG_PBL',
}

export const PAYWAY_IMAGES_SRC = `${process.env.BASE_URL || '/web/'}img/payway/`

export const PAYWAY_IMAGES = [
  { img: 'alior.svg', id: [95, 1608] },
  { img: 'bfg.png', id: [98] },
  { img: 'bnp-paribas.png', id: [31, 508, 1035] },
  { img: 'bos.svg', id: [29, 86] },
  { img: 'bs-biala-rawska.png', id: [1520] },
  { img: 'bs-sztum.png', id: [1507] },
  { img: 'citi-handlowy.svg', id: [90] },
  { img: 'credit-agricole.png', id: [59, 1609] },
  { img: 'getin-bank.svg', id: [513] },
  { img: 'giropay.png', id: [1904] },
  { img: 'ing.svg', id: [68, 1602, 1702] },
  { img: 'inteligo.jpg', id: [1064] },
  { img: 'ipko.svg', id: [1063] },
  { img: 'kbs.png', id: [1519] },
  { img: 'mbank.jpg', id: [3, 17, 1600] },
  { img: 'mbs.png', id: [1522] },
  { img: 'millenium.svg', id: [12, 85] },
  { img: 'neo-bank.png', id: [1050] },
  { img: 'nest-bank.svg', id: [517] },
  { img: 'nicolaus-bank.svg', id: [1515] },
  { img: 'noble-bank.png', id: [514] },
  { img: 'pekao.svg', id: [52, 1704] },
  { img: 'plus-bank.jpeg', id: [131] },
  { img: 'pocztowy24.png', id: [108] },
  { img: '1806.svg', id: [27, 1603] },
  { img: 'sgb-lututow.jpeg', id: [1510] },
  { img: 'toyota.svg', id: [117] },
  { img: 'apple-pay.svg', id: [1513] },
  { img: 'google-pay.svg', id: [1512] },
  { img: 'masterpass.svg', id: [1505] },
  { img: 'visa-checkout.svg', id: [1511] },
  { img: 'blik-place-pozniej.png', id: [523] },
  { img: 'smartney.png', id: [700] },
  { img: 'payka.png', id: [701] },
  { img: 'pay-po.png', id: [705] },
  { img: 'ideal.svg', id: [1901] },
  { img: 'eps.svg', id: [1905] },
  { img: 'bancomat.svg', id: [1906] },
  { img: 'my-bank.svg', id: [1907] },
  { img: 'satispay.svg', id: [1908] },
  { img: 'sepa.svg', id: [1909] },
  { img: 'skrill.svg', id: [1910] },
  { img: 'klarna.svg', id: [1911] },
  { img: 'sofort.svg', id: [1912] },
  { img: 'paysafecard.svg', id: [1913] },
  { img: 'paysafecash.svg', id: [1914] },
  { img: 'bancontact.svg', id: [1915] },
  { img: 'pay-pal.svg', id: [1916] },
  { img: '1917.svg', id: [1917] },
  { img: '1918.svg', id: [1918] },
  { img: '1920.svg', id: [1920] },
  { img: '1921.svg', id: [1921] },
  { img: '1020.svg', id: [1020] },
  { img: '1955.svg', id: [1955] },
  { img: '1956.svg', id: [1956] },
  { img: '711.svg', id: [711] },
  // banki PISowe
  { img: 'alior-PIS.svg', id: [1802] },
  { img: 'bnp-paribas-PIS.png', id: [1804] },
  { img: 'bos-PIS.svg', id: [1813] },
  { img: 'credit-agricole-PIS.png', id: [1809] },
  { img: 'getin-bank-PIS.svg', id: [1801] },
  { img: 'ing-PIS.svg', id: [1808] },
  { img: 'inteligo-PIS.jpg', id: [1810] },
  { img: 'mbank-PIS.jpg', id: [1800] },
  { img: 'millenium-PIS.svg', id: [1807] },
  { img: 'nest-bank-PIS.svg', id: [1814] },
  { img: 'pekao-PIS.svg', id: [1805] },
  { img: 'pko-PIS.svg', id: [1803] },
  { img: 'pocztowy24-PIS.png', id: [1811] },
  { img: '1806.svg', id: [1806] },
  { img: 'mbs-PIS.png', id: [] },
  { img: 'bfg-PIS.png', id: [] },
  { img: 'bs-biala-rawska-PIS.png', id: [] },
  { img: 'citi-handlowy-PIS.svg', id: [] },
  { img: 'kbs-PIS.png', id: [] },
  { img: 'nicolaus-bank-PIS.svg', id: [] },
  { img: 'noble-bank-PIS.png', id: [] },
  { img: 'plus-bank-PIS.jpeg', id: [] },
  { img: 'sgb-lututow-PIS.jpeg', id: [] },
  { img: 'toyota-PIS.svg', id: [] },
]

export const singlePaywayWithoutImage = () => {
  return {
    id: 9,
    type: BACKEND_PAYWAY_TYPES.type1,
    text: i18n.global.t('paywall.paywaySingle.accountAtAnotherBank'),
  }
}
